import React from "react";
export default function index() {
  const Test = () => {
    const msg = {
      Interface: "TCPIP",
      TCPIPAddress: "17.17.1.22",
      TCPIPPort: "9100",
      Method: "Printer.TestPrint",
    };
    const client = WebSocket("ws://192.168.1.22:8055/SATOPrinterAPI");
    client.onopen = (e) => {
      console.log("open", e);
    };
    client.onerror = (e) => {
      console.log("error", e);
    };
    client.onmessage = (e) => {
      console.log("meassge", e);
      const data = JSON.parse(e.data);
      console.log("message", e);
    };
  };
  return (
    <button className="btn btn-primary" onClick={() => Test()}>
      Open Socket
    </button>
  );
}
